module.exports = __webpack_public_path__ + "img/banner_1024.4968643a.webp";